import { getResponseJson } from '../../../services/getresponsejson.js';

function createWorkPageDetailService(serviceRoutes) {
  const initializePage = encounterId => {
    return fetch(`${serviceRoutes.initializePage}?encounterId=${encounterId}`, {
      credentials: 'include'
    })
    .then(getResponseJson);
  };

  // returns encounterId, updatedEncounterLineItem
  const acceptEncounterLineItem = (encounterLineItemId, encounterId, reasonOptionIdList) => {
    const unserializedRequestBody = {
      encounterId,
      encounterLineItemId,
      isAccepted: true,
      reasonOptionIdList
    };

    return fetch(serviceRoutes.acceptEncounterLineItem, {
      credentials: 'include',
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(unserializedRequestBody)
    })
    .then(getResponseJson);
  };

  // returns encounterId, updatedEncounterLineItem
  const rejectEncounterLineItem = (
    encounterLineItemId,
    encounterId,
    reasonOptionIdList
  ) => {
    const unserializedRequestBody = {
      encounterId,
      encounterLineItemId,
      reasonOptionIdList,
      isRejected: true
    };

    return fetch(serviceRoutes.rejectEncounterLineItem, {
      credentials: 'include',
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(unserializedRequestBody)
    })
    .then(getResponseJson);
  };

  // returns completedEncounterId, nextEncounterId
  const completeEncounterReview = encounterId => {
    const unserializedRequestBody = {
      encounterId
    };

    return fetch(serviceRoutes.completeEncounterReview, {
      credentials: 'include',
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(unserializedRequestBody)
    })
    .then(getResponseJson);
  };

  return {
    initializePage,
    acceptEncounterLineItem,
    rejectEncounterLineItem,
    completeEncounterReview,
    serviceRoutes
  };
}

export { createWorkPageDetailService };
